import { useInfiniteQuery } from '@northladder/services';

import { B2B_SERVICE_API } from '../b2bApiClient';
import { IPagination, ISignUpListingResponse } from '../types';

/**
 * Query key for fetching all the sign-ups listing.
 */
export const FETCH_SING_UP_LISTING_QUERY_KEY = 'signup-listing-query-key';

/**
 * This performs a query to fetch all the sign-ups listing.
 */
export const useSignupsListingQuery = ({ limit, page }: IPagination) =>
  useInfiniteQuery<ISignUpListingResponse, Error>({
    queryKey: [FETCH_SING_UP_LISTING_QUERY_KEY, limit, page],
    queryFn: async ({ pageParam = page }): Promise<ISignUpListingResponse> => {
      const result = await B2B_SERVICE_API.fetchSignupListing({
        limit,
        page: pageParam,
      });
      return result;
    },
    initialPageParam: page,
    maxPages: 1,
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    getPreviousPageParam: (firstPage) => firstPage.previousPage ?? undefined,
  });
